import { DeckDTO } from '@/generated';
import { Autocomplete, TextField } from '@mui/material';

export const DeckAutocomplete = (props: { decks: DeckDTO[]; selectedDeckId?: string; setSelectedDeckId: (deckId?: string) => void }) => {
  const { decks, selectedDeckId, setSelectedDeckId } = props;

  return (
    <Autocomplete
      autoHighlight
      id="tags-outlined"
      defaultValue={decks?.find((d) => d.id === selectedDeckId)}
      onChange={(event, deck) => {
        if (deck) setSelectedDeckId(deck.id);
        else setSelectedDeckId(undefined);
      }}
      options={decks ?? []}
      getOptionLabel={(option) => option.name}
      filterSelectedOptions
      sx={{ minWidth: 200, paddingTop: 1 }}
      renderInput={(params) => <TextField variant="outlined" {...params} label={`Deck`} placeholder={selectedDeckId ? `Select Deck` : undefined} />}
    />
  );
};
